import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=49407091&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"
import style0 from "./page8.vue?vue&type=style&index=0&id=49407091&prod&scoped=true&lang=css"
import style1 from "./page8.vue?vue&type=style&index=1&id=49407091&prod&scoped=true&lang=css"
import style2 from "./page8.vue?vue&type=style&index=2&id=49407091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49407091",
  null
  
)

export default component.exports